import { Signal } from "@suse-o11y/signal";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectTimeRange } from "../../../app/state/view/timeline/TimelineSelectors";
import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import { useNavigateFrom } from "../link";

export const useTimelineInterval = (): Signal<TimeRange> => {
	const navigateFrom = useNavigateFrom();
	const timeRange = useSelector(selectTimeRange);

	return useMemo(
		() =>
			Signal(
				() => timeRange,
				(nextTimeRange) => {
					navigateFrom("*", {
						search: (search) => ({
							...search,
							timestamp: nextTimeRange.isSpecific() ? search.timestamp : undefined,
							timeRange: nextTimeRange,
						}),
					});
				},
			),
		[navigateFrom, timeRange],
	);
};
